export default "__VITE_ASSET__BbFuZhjt__"